// angular modules
import { NgModule, ErrorHandler } from '@angular/core';
import { BugsnagService } from './bugsnag.service';
import { BcErrorHandler } from './bc-error-handler.service';
import { UserService } from '../../services';


// create a factory which will return the bugsnag error handler
export const errorHandlerFactory = (bugnsagService: BugsnagService, userService: UserService) => {
  return new BcErrorHandler(bugnsagService, userService);
};

@NgModule({
  providers: [
    {
      provide: BcErrorHandler,
      useFactory: errorHandlerFactory,
      deps: [BugsnagService, UserService]
    },
    {
      provide: ErrorHandler,
      useFactory: errorHandlerFactory,
      deps: [BugsnagService, UserService]
    }
  ]
})
export class BcBugSnagModule { }
